import { lazy } from 'react';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import BusIcon from '@mui/icons-material/LocalShipping'; // Icon for Bus
import AssignmentIcon from '@mui/icons-material/Assignment';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import UserCollectionReport from '../Bus/UserCollectionReport';
import BookingSummaryReport from '../Bus/BookingSummaryReport';
import SearchPNR from '../Bus/SearchPNR';
import GroupBoardingReport from '../Bus/GroupBoardingReport'
import AgentRecharge from '../Bus/AgentRecharge';
import { useSelector } from 'react-redux';
import { encrypt } from './loginDecode';
const Trips = lazy(() => import('../Booking'));
const Login = lazy(() => import('../Login'));
const QuickViewReport = lazy(() => import('../Bus/QuickViewReport'))
const QuickViewDetailReport = lazy(() => import('../Bus/QuickViewReportDetailReport'))
const BranchRecharge = lazy(() => import('../BranchRecharge'))

function isJobIdPresent(roleData, jobIdToCheck) {
    return roleData.some(job => job.JobID === jobIdToCheck);
}
export const useMainMenuList = () => {
    const common = useSelector(state => state.common);
    const { userDetails, roleData } = common
    let isQuickView = (userDetails?.isAdmin == "1" || userDetails?.isMTPLAdmin == 1 || isJobIdPresent(roleData, 36)) && (userDetails?.ConductorID === 0)
    let isUserWiseColl = userDetails?.isAdmin == "1" || userDetails?.isMTPLAdmin == 1 || isJobIdPresent(roleData, 35)
    let isBookingSummaryReport = (userDetails?.isAdmin == "1" || userDetails?.isMTPLAdmin == 1 || isJobIdPresent(roleData, 153)) && (userDetails?.ConductorID === 0)
    let isSearchPNR = userDetails?.isAdmin == "1" || userDetails?.isMTPLAdmin == 1 || isJobIdPresent(roleData, 86)
    let isNearByBuses = userDetails?.isAdmin == "1" || userDetails?.isMTPLAdmin == 1 || isJobIdPresent(roleData, 305)
    let isGroupBoardingReport = userDetails?.isAdmin == "1" || userDetails?.isMTPLAdmin == 1 || isJobIdPresent(roleData, 159)
    let isAgentRecharge = userDetails?.isAdmin == "1" || userDetails?.isMTPLAdmin == 1 || isJobIdPresent(roleData, 74)
    const data = {
        intCompanyID: userDetails?.CompanyID,
        intBranchID: userDetails?.isAdmin == "1" || userDetails?.isMTPLAdmin == 1 ? 0 : userDetails?.BranchID,
        intUserID: userDetails?.UserID
    }
    const stringData = JSON.stringify(data)
    const endcryptData = encrypt(stringData)
    let BusCrsCheckSum = userDetails?.BusCrsCheckSum
    const url = `https://cargo.mavenconnect.biz/?view=Dashboard&data=${endcryptData}||BusCrsCheckSum=${BusCrsCheckSum}`

    return [{
        id: 1, mainName: "Bus", icon: <DirectionsBusIcon />, subMenu: [
            { mainName: "Booking", path: '/BusBooking', element: <Trips />, enable: true },
            { mainName: "Quick View", path: '/QuickView', element: <QuickViewReport />, jobId: 36, enable: isQuickView },
            { mainName: "Quick View Detail", path: '/QuickViewDetail', element: <QuickViewDetailReport />, jobId: 36, enable: isQuickView },
            { mainName: "UserWise Collection", path: '/userWiseCollection', element: <UserCollectionReport />, jobId: 35, enable: isUserWiseColl },
            { mainName: "Booking Summary Report", path: '/bookingSummary', element: <BookingSummaryReport />, jobId: 153, enable: isBookingSummaryReport },
            { mainName: "Search PNR", path: '/searchPNR', element: <SearchPNR />, jobId: 86, enable: isSearchPNR },
            { mainName: "Near By Buses", path: '/', element: <Login />, jobId: 305, enable: isNearByBuses },
            { mainName: "Group Boarding Report", path: '/groupBoarding', element: <GroupBoardingReport />, jobId: 159, enable: isGroupBoardingReport },
            { mainName: "Agent Recharge (+)", path: '/AgentRecharge', element: <AgentRecharge />, jobId: 74, enable: isAgentRecharge },
        ]
    },
    {
        id: 2, mainName: "Cargo", icon: <BusIcon />, subMenu: [
            { mainName: "Dashboard", path: url, element: <Login />, enable: true, isNewTabOpen: true },
            // Undeveloped — hidden until implemented
            // { mainName: "Booking", path: '', element: <Login /> },
            // { mainName: "Dispatch", path: '', element: <Login /> },
            // { mainName: "Receive", path: '', element: <Login /> },
            // { mainName: "Delivery", path: '', element: <Login /> },
            // { mainName: "Branch Transfer", path: '', element: <Login /> },
            // { mainName: "Cancel Transfer", path: '', element: <Login /> },
            // { mainName: "Branch Transfer Receive", path: '', element: <Login /> },
            // { mainName: "Branch Transfer Received", path: '', element: <Login /> },
            // { mainName: "Recharge", path: '', element: <Login /> },
            // { mainName: "Branch Stock", path: '', element: <Login /> },
            // { mainName: "Booking Summary Report", path: '', element: <Login /> },
            // { mainName: "Common LR", path: '', element: <Login /> },
             { mainName: "Cargo Branch Recharge", path: '/branchRecharge', element: <BranchRecharge />, enable: true },
            // { mainName: "Block LR", path: '', element: <Login /> },
            // { mainName: "Dispatch Report", path: '', element: <Login /> },
            // { mainName: "Receive Report", path: '', element: <Login /> },
        ]
    },
    {
        id: 3, mainName: "Voucher", icon: <AssignmentIcon />, subMenu: [
            { mainName: "Credit Report", path: '', element: <Login />, enable: true },
            { mainName: "Receive Report", path: '', element: <Login />, enable: true },
            { mainName: "Pending Report", path: '', element: <Login />, enable: true },
        ]
    },
    {
        id: 4, mainName: "Trip And Location", icon: <LocationOnIcon />, subMenu: [
            { mainName: "Trips", path: '', element: <Login />, enable: true },

        ]
    }
    ]
}